import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/css/NavBar.css";

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 724);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const navigate = useNavigate();
  const menuRef = useRef(null);
  const burgerRef = useRef(null);

  const handleNavigation = (path) => {
    setIsMobileMenuOpen(false);
    navigate(path);
  };

  const toggleMobileMenu = () => isSmallScreen && setIsMobileMenuOpen((prev) => !prev);

  const togglePopup = () => {
    if (isPopupOpen) {
      document.querySelector(".popup-overlay").classList.add("closing");
      setTimeout(() => setIsPopupOpen(false), 300); // Délai pour l'animation
    } else {
      setIsPopupOpen(true);
    }
  };

  useEffect(() => {
    const checkScreenSize = () => setIsSmallScreen(window.innerWidth <= 724);
    const closeMenuOnResize = () => window.innerWidth > 345 && setIsMobileMenuOpen(false);

    const handleResize = () => {
      checkScreenSize();
      closeMenuOnResize();
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClickOutside = useCallback(
    (event) => {
      if (
        isSmallScreen &&
        !menuRef.current?.contains(event.target) &&
        !burgerRef.current?.contains(event.target)
      ) {
        setIsMobileMenuOpen(false);
      }
    },
    [isSmallScreen]
  );

  useEffect(() => {
    if (isSmallScreen) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isSmallScreen, handleClickOutside]);

  const links = [
    { path: "/", label: "🏡 Home" },
    { path: "/bump", label: "🚀 Bumps" },
    { path: "/dashboard/@home/", label: "⚙️ Dashboard" },
    {
      href: "https://discord.com/application-directory/1144747722944024596/store/1274787677253799997",
      label: "Premium 🚀",
      external: true,
    },
    { path: "", label: "🪛" },
  ];

  return (
    <>
      <div className="navbar">
        {isSmallScreen && (
          <div ref={burgerRef} className="burger" onClick={toggleMobileMenu}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        )}
        <div ref={menuRef} className={`menu ${isMobileMenuOpen || !isSmallScreen ? "" : "hidden"}`}>
          {links.map(({ path, label, href, external }, index) => (
            <React.Fragment key={label}>
              {href ? (
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={href}
                  className="nav-link"
                >
                  {label}
                </a>
              ) : label === "🪛" ? (
                <button onClick={togglePopup} className="nav-link">
                  {label}
                </button>
              ) : (
                <button onClick={() => handleNavigation(path)} className="nav-link">
                  {label}
                </button>
              )}
              {!isSmallScreen && index < links.length - 1 && <span className="separator">|</span>}
            </React.Fragment>
          ))}
        </div>
      </div>
      {isPopupOpen && (
        <div className="popup-overlay" onClick={togglePopup}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <h2>Settings</h2>
            <p>Here you can configure some settings for a better experience.</p>
            <blockquote>&gt;&gt; No Settings Yet</blockquote>
            <button onClick={togglePopup}>Save & Close</button>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
